module.exports = __webpack_public_path__ + "img/d763324.jpg";